import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  titleInput: {
    width: '100%',
  },
}));

export default function TestTitle({ value, handeChange }) {
  const classes = useStyles();
  return (
    <Grid item xs={12}>
      <TextField
        id="questionTitle"
        label="عنوان سوال"
        variant="outlined"
        className={classes.titleInput}
        value={value}
        onChange={e => handeChange(e.target.value)}
      />
    </Grid>
  );
}
